import { FeatureToggleProvider } from "@/features/feature-toggle/context-api/providers/feature-toggle-provider";
import { ClientWalletProvider } from "@/features/wallet/context-api/providers/client-wallet";
import { makeContractDatasource } from "@/main/factories/datasources/contract-datasource-factory";
import { makeNotificationDatasource } from "@/main/factories/datasources/notification-datasource-factory";
import { makeSSOApiDatasource } from "@/main/factories/datasources/sso-api-datasource-factory";
import { makeWalletDatasource } from "@/main/factories/datasources/wallet-datasource-factory";
import { makeLocalStorage } from "@/main/factories/local-storage/local-storage-factory";
import { makeGetUserPermissions } from "@/main/factories/usecases/permissions/getUserPermissionsFactory";
import { getCachedAuthClientInstance } from "@/main/singleton/cached-auth-client-instance";
import { AuthProvider } from "@/shared/presentation/context-api/providers/auth";
import { BalanceProvider } from "@/shared/presentation/context-api/providers/balance";
import { NotificationProvider } from "@/shared/presentation/context-api/providers/notification";
import { ProductProvider } from "@/shared/presentation/context-api/providers/product";
import { TransactionsProvider } from "@/shared/presentation/context-api/providers/transaction";
import { UserPermissionProvider } from "@/shared/presentation/context-api/providers/user-permission";
import FlagProvider from "@unleash/proxy-client-react";
import React from "react";
import { makeEntityDatasource } from "./factories/datasources/entity-datasource-factory";
var config = {
    url: "https://rockos-unleash.rockcontent.com/proxy",
    clientKey: "83de761b8df7cd38da874f1ec0fd3ae5b5a7ac245f76b43199b794efb94f9c5b",
    appName: "rockos-account-shell",
    storage: {
        save: function (name, data) { return localStorage.setItem(name, data); },
        get: function (name) { return localStorage.getItem(name); },
    },
};
export var AppProvidersWrapper = function (_a) {
    var children = _a.children;
    return (React.createElement(FlagProvider, { config: config },
        React.createElement(AuthProvider, { authClient: getCachedAuthClientInstance(), ssoApi: makeSSOApiDatasource(), entityApi: makeEntityDatasource(), cacheStorage: makeLocalStorage() },
            React.createElement(UserPermissionProvider, { getUserPermissions: makeGetUserPermissions() },
                React.createElement(FeatureToggleProvider, null,
                    React.createElement(ClientWalletProvider, null,
                        React.createElement(BalanceProvider, { walletDatasource: makeWalletDatasource() },
                            React.createElement(TransactionsProvider, { walletDatasource: makeWalletDatasource() },
                                React.createElement(ProductProvider, { contractDatasource: makeContractDatasource(), entityDatasource: makeEntityDatasource() },
                                    React.createElement(NotificationProvider, { notificationApi: makeNotificationDatasource() }, children))))))))));
};
